import React from 'react'
import PropTypes from 'prop-types'
import { useMedia } from '@sainsburys-tech/boltui-hooks'
import * as Styled from '../SizeGuide/SizeGuide.styles'

const getSizeGuidePath = brand => {
  if (brand.toLowerCase() === 'too young to be bored') {
    return 'TYTBB'
  }
  if (brand.toLowerCase() === 'jd williams') {
    return 'JDW'
  }
  return brand.toUpperCase().replace(/ /g, '-')
}

const BrandSizeGuide = ({ brand }) => {
  const isMobile = useMedia([false, true], false, [`(min-width: 768px)`, `(max-width: 768px)`])
  const imgSrc = `${getSizeGuidePath(brand)}-SIZE-GUIDE-${isMobile ? 'MOBILE' : 'DESKTOP'}`
  return (
    <Styled.Image
      data-test='brand-size-image'
      src={`//media.4rgos.it/i/Argos/${imgSrc}`}
      alt={`${brand} size guide`}
      width='900'
    />
  )
}

BrandSizeGuide.propTypes = {
  brand: PropTypes.string.isRequired
}

export default BrandSizeGuide
